import {takeEvery, takeLatest} from 'redux-saga/effects'
import Api from '../services/Api'

/* ------------- Types ------------- */

import {StartupTypes} from '../reducers/startup/StartupRedux'
import {LoginTypes} from '../reducers/login/LoginRedux'
import {UserTypes} from '../reducers/user'
import {PatientTypes} from '../reducers/patient/index'

/* ------------- Sagas ------------- */

import {
    requestLogin,
    requestRegister,
    successLogin,
    successLogout,
    requestForgotPassword,
    requestResetPassword
} from './login/LoginSagas'
import {
    requestGetUserData,
    requestGetAllUserInfo,
    requestSpecificUser,
    requestUpdateSpecificUser,
    sendSpecificUserInvite,
    requestCreateUser,
    userProfileRequest, requestCreateMultipleUser,
    requestUserResetPassword,
} from './user/UserSagas'
import {
    requestGetAllPatientInfo,
    requestSpecificPatientDocument,
    requestUpdateSpecificPatientSign,
    requestSpecificPatient,
    requestUpdateSpecificPatient,
    requestCreatePatient,
    requestPatient,
    requestClearAllPatients
} from './patient/PatientSagas';

import {startup} from './startup/StartupSagas'

/* ------------- API ------------- */

const api = Api.apiCreate(process.env.API_URL)

/* ------------- Connect Types To Sagas ------------- */

export default function * rootSaga() {
    yield [
        takeLatest(StartupTypes.STARTUP, startup),
        takeLatest(LoginTypes.CREATE_LOGIN_REQUEST, requestLogin, api),
        takeLatest(LoginTypes.CREATE_LOGIN_SUCCESS, successLogin, api),
        takeLatest(LoginTypes.CREATE_LOGOUT_REQUEST, successLogout, api),
        takeLatest(LoginTypes.CREATE_REGISTER_REQUEST, requestRegister, api),
        takeEvery(LoginTypes.CREATE_FORGOT_REQUEST, requestForgotPassword, api),
        takeEvery(LoginTypes.RESET_PASSWORD_REQUEST, requestResetPassword, api),
        // takeLatest(LoginTypes.CREATE_LOGOUT_SUCCESS, successLogout, api),

        takeLatest(UserTypes.GET_USER_REQUEST, requestGetUserData, api),
        takeEvery(UserTypes.SEND_SPECIFIC_USER_INVITE_REQUEST, sendSpecificUserInvite, api),
        takeEvery(UserTypes.UPDATE_SPECIFIC_USER_REQUEST, requestUpdateSpecificUser, api),
        takeLatest(UserTypes.CHANGE_PASSWORD_REQUEST, requestUserResetPassword, api),
        takeLatest(UserTypes.GET_ALL_USER_INFO_REQUEST, requestGetAllUserInfo, api),

        takeEvery(UserTypes.GET_SPECIFIC_USER_REQUEST, requestSpecificUser, api),

        takeEvery(UserTypes.CREATE_SPECIFIC_USER_REQUEST, requestCreateUser, api),
        takeEvery(UserTypes.CREATE_MULTIPLE_USER_REQUEST, requestCreateMultipleUser, api),
        takeEvery(UserTypes.GET_USER_PROFILE_REQUEST, userProfileRequest, api),

        takeLatest(PatientTypes.GET_ALL_PATIENT_INFO_REQUEST, requestGetAllPatientInfo, api),
        takeLatest(PatientTypes.GET_SPECIFIC_PATIENT_REQUEST, requestSpecificPatient, api),
        takeLatest(PatientTypes.GET_SPECIFIC_PATIENT_DOCUMENT_REQUEST, requestSpecificPatientDocument, api),
        takeLatest(PatientTypes.UPDATE_SPECIFIC_PATIENT_REQUEST, requestUpdateSpecificPatient, api),
        takeLatest(PatientTypes.UPDATE_SPECIFIC_PATIENT_SIGN_REQUEST, requestUpdateSpecificPatientSign, api),
        takeLatest(PatientTypes.CREATE_SPECIFIC_PATIENT_REQUEST, requestCreatePatient, api),
        takeLatest(PatientTypes.GET_ALL_PATIENTS_REQUEST, requestPatient, api),
        takeLatest(PatientTypes.CLEAR_ALL_PATIENTS_REQUEST, requestClearAllPatients, api),
    ]
}
